export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/service-coupon.f76363eb-a3d227.png";